import {
  FieldValues,
  useFieldArray,
  useFormContext,
  useWatch
} from 'react-hook-form';

import { BoxIcon } from '#atoms';
import { formatTime } from 'src/refactor_shared/lib/parseTime';

export const ScheduleDateItem = ({
  day,
  labelDay,
  applyMaxWidth = true
}: {
  day: string;
  labelDay: string;
  applyMaxWidth?: boolean;
}) => {
  const { control, register, setValue } = useFormContext();
  const date = useFieldArray({
    control,
    name: day
  });

  const sameTimeWatcher = useWatch({
    control,
    name: '7'
  });

  const dayWatcher = useWatch({
    control,
    name: day
  });

  return (
    <>
      {!sameTimeWatcher && dayWatcher ? (
        <div className="flex flex-col gap-10">
          {date.fields.map((item, index) => (
            <div className="flex gap-8 items-center" key={item.id}>
              <input
                {...register(`${day}.${index}.startAt`, {
                  onBlur: e => {
                    setValue(
                      `${day}.${index}.startAt`,
                      formatTime(e.target.value)
                    );
                  }
                })}
                className={`w-full h-44 px-16 text-[#EAE8ED] bg-[#18171C] border border-solid border-[#4D495A] rounded-8 ${
                  applyMaxWidth && date.fields.length > 1 ? 'max-w-120' : ''
                }`}
              />
              <p>~</p>
              <input
                {...register(`${day}.${index}.endAt`, {
                  onBlur: e => {
                    setValue(
                      `${day}.${index}.endAt`,
                      formatTime(e.target.value)
                    );
                  }
                })}
                className={`w-full h-44 px-16 text-[#EAE8ED] bg-[#18171C] border border-solid border-[#4D495A] rounded-8 ${
                  applyMaxWidth && date.fields.length > 1 ? 'max-w-120' : ''
                }`}
              />
              {index ? (
                <button type="button" onClick={() => date.remove(index)}>
                  <BoxIcon type="wastebasket" onlyIcon size={18} />
                </button>
              ) : null}
            </div>
          ))}
          <button
            type="button"
            className="self-end text-[#9170F2]"
            onClick={() =>
              date.append({
                startAt: '',
                endAt: ''
              })
            }
          >
            + 시간 추가
          </button>
        </div>
      ) : (
        <p
          className={`${
            dayWatcher ? 'text-[#EAE8ED]' : ''
          } bg-[#1F1E25] py-[11.5px] px-16 text-[#5C576B] rounded-8 w-full`}
        >
          {labelDay}요일은 수업이 {dayWatcher ? '있어요' : '없어요'}
        </p>
      )}
    </>
  );
};

export const ScheduleSameDateItem = ({
  day,
  applyMaxWidth = true,
  watcher
}: {
  day: string;
  applyMaxWidth?: boolean;
  watcher: boolean;
}) => {
  const { register, setValue, control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: '7'
  });

  return (
    <>
      {watcher ? (
        <div className="flex flex-col gap-10">
          {fields.map((item: { id: string }, index: number) => (
            <div className="flex gap-8 items-center" key={item.id}>
              <input
                {...register(`${day}.${index}.startAt`, {
                  onBlur: e => {
                    setValue(
                      `${day}.${index}.startAt`,
                      formatTime(e.target.value)
                    );
                  }
                })}
                className={`w-full h-44 px-16 text-[#EAE8ED] bg-[#18171C] border border-solid border-[#4D495A] rounded-8 ${
                  applyMaxWidth && fields.length > 1 ? 'max-w-120' : ''
                }`}
              />
              <p>~</p>
              <input
                {...register(`${day}.${index}.endAt`, {
                  onBlur: e => {
                    setValue(
                      `${day}.${index}.endAt`,
                      formatTime(e.target.value)
                    );
                  }
                })}
                className={`w-full h-44 px-16 text-[#EAE8ED] bg-[#18171C] border border-solid border-[#4D495A] rounded-8 ${
                  applyMaxWidth && fields.length > 1 ? 'max-w-120' : ''
                }`}
              />
              {index ? (
                <button type="button" onClick={() => remove(index)}>
                  <BoxIcon type="wastebasket" onlyIcon size={18} />
                </button>
              ) : null}
            </div>
          ))}
          <button
            type="button"
            className="self-end text-[#9170F2]"
            onClick={() =>
              append({
                startAt: '',
                endAt: ''
              })
            }
          >
            + 시간 추가
          </button>
        </div>
      ) : null}
    </>
  );
};

ScheduleDateItem.Same = ScheduleSameDateItem;
